import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import moment from "moment";

function CountdownRow({ date, time, interval }) {
  const [currentTime, setCurrentTime] = useState(moment());
  const [isValid, setIsValid] = useState(false);
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    if (!date || !time || !interval) {
      setIsValid(false);
      return;
    }

    const targetDateTime = moment(`${date} ${time}`, "D/M/YYYY h:mm A");
    if (!targetDateTime.isValid()) {
      setIsValid(false);
      return;
    }

    const finalEndTime = moment(targetDateTime).add(Number(interval), "minutes");

    setEndTime(finalEndTime);
    setIsValid(currentTime.isBefore(finalEndTime) && currentTime.isAfter(targetDateTime));
  }, [date, time, interval, currentTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      {isValid && endTime ? (
        <div className="text-success fs-3" style={{ fontWeight: "bolder" }}>
          <Countdown
            date={endTime.toDate()}
            onComplete={() => console.log("Countdown completed")}
          />
        </div>
      ) : (
        <p className="fs-6 text-danger">Countdown has not started yet or has already passed.</p>
      )}
    </div>
  );
}

export default CountdownRow;
